import {atom, selectorFamily, useSetRecoilState} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {api} from '../../api';
import {createQuerySuspense} from '../../lib/helpers/create-query-suspense.helper';

const {postContractsFindByIDs} = api.contracts;

const postContractsFindByIdsQueryRefresh = atom<number>({
  key: 'postContractsFindByIDsRefresh',
  default: 0,
});

const postContractsFindByIdsQuery = selectorFamily({
  key: 'postContractsFindByIDs',
  get(params: Parameters<typeof postContractsFindByIDs>[0]) {
    return async ({get}) => {
      get(postContractsFindByIdsQueryRefresh);
      try {
        const {data} = await postContractsFindByIDs(params);
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const usePostContractsFindByIdsQuerySuspenseRefresh = () => {
  const refreshFn = useSetRecoilState(postContractsFindByIdsQueryRefresh);
  return () => refreshFn((prev) => prev + 1);
};

export const usePostContractsFindByIdsQuerySuspense = createQuerySuspense(
  postContractsFindByIdsQuery,
  postContractsFindByIdsQueryRefresh,
);
